module.exports = __webpack_public_path__ + "static/media/400409_01.2b532f4a.png";